import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
  name: 'localizedDecimal'
})
export class LocalizedDecimalPipe implements PipeTransform {

  constructor(private decimalPipe:DecimalPipe) {
  }

  transform(value: string | undefined | number): string | null {
    return this.decimalPipe.transform(value,'1.2-2','es-ES');
  }

}
